import React from 'react';

import { useNavigate } from 'react-router';

import Layout from '../components/common/Layout';

const InClosing = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="wait-list-page">
        <div className="page-inner">
          <h2>In closing, docs outs</h2>
          <div className="main-message">
            <p>
              <b>What it means:</b>You have been fully validated and are approved for funding.
            </p>
            <p>
              <b>What you should do:</b> Check your email for a grantee agreement, which will be
              sent via DocuSign. Sign the grantee agreement to release funds.
            </p>
          </div>
          <button className="primary-btn" onClick={() => navigate('/dashboard')}>
            Return to Dashboard
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default InClosing;
